module.exports = __webpack_public_path__ + "static/media/grandmas-and-guitars.0a67918d.mov";